"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultPlaceTopPlace = void 0;
exports.defaultPlaceTopPlace = {
    id: 1,
    name: 'Tycoon Court-Block A',
    caption: 'Mid-levels West',
    image: 'https://images.okay.com/Property/Folder150/296974_636718501594729307.jpg',
    link: '#hi',
    listings: 5,
    avgPrice: 12300000,
    avgPsf: 14200,
    rentListingsCount: 12,
    saleListingsCount: 8,
    unit: 600,
    tower: 5,
    builtYear: 2003,
    saleLink: '#buy',
    rentLink: '#rent',
};
